import template from 'text!./templates/ho-flow.html';
import 'edge/platform/flow/FlowFactory';
import 'edge/endorsement/ho/config/FlowConfig';
import EndorsementStateUtils from 'edge/endorsement/common/utils/EndorsementStateUtils';
import EndorsementSubflowUtils from 'edge/endorsement/common/utils/EndorsementSubflowUtils';

export default [function () {
    return {
        template: template,
        'scope': {
            'wizard': '=',
            'flow': '=',
            'isStateVisible': '='
        },
        'controller': ['$rootScope', '$scope', '$state', 'endorsement.EndorsementService', function ($rootScope, $scope, $state, EndorsementService) {
            var stateMappings = {
                HOValuables: 'valuables',
                HOCoverages: 'coverages',
                HOMortgagee: 'mortgagee'
            };
            var updateCoverages = EndorsementSubflowUtils.updateCoverages($scope, $state, EndorsementService);

            $scope.toState = EndorsementStateUtils.toState($scope, stateMappings);
            $scope.hasState = EndorsementStateUtils.hasState($scope);
            $scope.tileState = EndorsementStateUtils.tileState($scope);
            $scope.showOnState = EndorsementStateUtils.showOnState($scope);
            $scope.showEndorsementChangeArea = showEndorsementChangeArea;
            $scope.next = EndorsementStateUtils.next($scope);
            $scope.quote = EndorsementSubflowUtils.quote($rootScope, $scope.next);
            $scope.onBaseCovChange = EndorsementSubflowUtils.onBaseCovChange($scope, 'homeowners', updateCoverages);
            $scope.onAdditionalCovChange = EndorsementSubflowUtils.onAdditionalCovChange($scope, 'homeowners', updateCoverages);

            /**
             * Determine whether one state of the group should be displayed
             * @returns {boolean}
             */
            function showEndorsementChangeArea() {
                var states = Object.keys(stateMappings);
                return states.some(function (state) {
                    return state === $scope.wizard.state.name;
                });
            }
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/endorsement/ho/directives/HOFlow.js
// module id = 1458
// module chunks = 0